import { useEffect, useState } from "react";

import styles from "./index.module.css";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/reduxHooks";
import { addText, updateTextProp } from "../../../../store/slices/viewSlice";
import ColorPicker from "../../ColorPicker";
import RangeSlider from "../../RangeSlider";

const availableColors = [
  "#dedede",
  "#939495",
  "#747163",
  "#f6e44a",
  "#f4a323",
  "#fff98a",
  "#20419a",
  "#0ca2bd",
  "#353f4b",
  "#ff7700",
  "#3f510d",
  "#02642e",
  "#c3f17a",
  "#6fcf91",
  "#b1ecb5",
  "#b51717",
  "#ef4848",
  "#ffc2c4",
  "#5e3a8c",
  "#55387a",
  "#34101b",
];

const AddText = () => {
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [showOutlineColorPicker, setShowOutlineColorPicker] = useState(false);
  const [currentColor, setCurrentColor] = useState("#000");
  const dispatch = useAppDispatch();
  const selectedEffect = useAppSelector(
    (state: any) => state.canvases.selectedEffect
  );
  const selectedObject = useAppSelector(
    (state: any) => state.canvases.selectedObject
  );

  const selectedObject_test = useAppSelector((state: any) => state);

  //const [currentObj, setCurrentObj] = useState(null);
  const [currentText, setCurrentText] = useState("");

  useEffect(() => {
    console.log("desiging selectedObject___", selectedObject_test);

    if (!selectedObject) setCurrentText("");
    else setCurrentText(selectedObject.text);
  }, [selectedObject]);

  const handleUpdateProp = (prop: string, value?: any) => {
    dispatch(updateTextProp({ prop: prop, value: value }));
  };

  const handleChangeText = (text: string) => {
    if (selectedObject) {
      handleUpdateProp("text", text);
      setCurrentText(text);
    } else {
      setCurrentText(text);
    }
  };

  const handleAddText = () => {
    dispatch(addText(currentText));
    setCurrentText("");
  };

  const setNewColor = (color: any) => {
    setCurrentColor(color);
    dispatch(updateTextProp({ prop: "fill", value: color }));
  };
  const setStrokeColor = (color: any) => {
    dispatch(updateTextProp({ prop: "stroke", value: color }));
  };

  return (
    <>
      <>
        {!selectedObject || selectedObject.type !== "text" ? (
          <>
            <div className="font-bold text-2xl tracking-wide border-b border-solid border-lightgrey">
              {"Add New Text"}
            </div>
            <div className="my-4">
              <textarea
                className="border border-solid border-lightgrey resize-none w-full h-[94px] p-2 rounded-sm"
                name="productText"
                id="productText"
                placeholder="Text on product"
                value={selectedObject ? selectedObject.text : currentText}
                onChange={(e) => handleChangeText(e.target.value)}
              ></textarea>
              {!selectedObject ? (
                <button
                  className="text-white font-semibold bg-primaryred px-3 py-1 rounded-md"
                  onClick={handleAddText}
                >
                  Add Text
                </button>
              ) : (
                ""
              )}
            </div>
          </>
        ) : (
          <>
            <>
              {" "}
              <div className="font-bold text-2xl tracking-wide border-b border-solid border-lightgrey">
                {selectedObject ? "Edit Your Text" : "Add New Text"}
              </div>
              <div className="my-4">
                <textarea
                  className="border border-solid border-lightgrey resize-none w-full h-[94px] p-2 rounded-sm"
                  name="productText"
                  id="productText"
                  placeholder="Text on product"
                  value={selectedObject ? selectedObject.text : currentText}
                  onChange={(e) => handleChangeText(e.target.value)}
                ></textarea>
                {!selectedObject && (
                  <button
                    className="text-white font-semibold bg-primaryred px-3 py-1 rounded-md"
                    onClick={handleAddText}
                  >
                    Add Text
                  </button>
                )}
              </div>
              <div className="my-4">
                <div className="flex justify-between items-center py-2 border-t border-solid border-lightgrey">
                  <div className="font-bold">Font</div>
                  <div>
                    <select
                      className="w-[104%] cursor-pointer text-right outline-none"
                      name="font"
                      id="font"
                      value={
                        selectedObject
                          ? selectedObject.fontFamily
                          : "Times New Roman"
                      }
                      onChange={(e) =>
                        handleUpdateProp("fontFamily", e.target.value)
                      }
                    >
                      <option value="Times New Roman">Times New Roman</option>
                      <option value="Arial">Arial</option>
                    </select>
                  </div>
                </div>
                {selectedEffect?.printMethodDetails?.changeTextColor ? (
                  <div className="flex justify-between items-center py-2 border-t border-solid border-lightgrey">
                    <div className="font-bold">Text Color</div>
                    <div className="flex justify-center relative">
                      <div
                        onClick={() => setShowColorPicker((prev) => !prev)}
                        className="cursor-pointer w-[20px] h-[20px] rounded-full border-2 border-solid border-lightgrey"
                        style={{
                          backgroundColor: selectedObject
                            ? selectedObject.fill
                            : currentColor,
                        }}
                      ></div>
                      <ColorPicker
                        title="Choose text color"
                        colors={availableColors}
                        show={showColorPicker}
                        setShowColorPicker={setShowColorPicker}
                        setNewColor={setNewColor}
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="flex justify-between items-center gap-3 py-2 border-t border-solid border-lightgrey">
                  <div className="font-bold">Rotation</div>
                  <div className="flex w-full items-center gap-3">
                    <RangeSlider
                      min={-180}
                      max={180}
                      defaultValue={selectedObject ? selectedObject.angle : 0}
                      onChange={(angle: number) =>
                        handleUpdateProp("angle", angle)
                      }
                    />
                  </div>
                </div>
                {selectedObject &&
                selectedObject.stroke &&
                selectedEffect?.printMethodDetails?.changeStrokeColor ? (
                  <div className="flex justify-between items-center py-2 border-t border-solid border-lightgrey">
                    <div className="font-bold">Outline</div>
                    <div>
                      <select
                        className="w-[116%] cursor-pointer text-left outline-none"
                        name="outline"
                        value={
                          selectedObject && selectedObject.stroke ? "on" : "off"
                        }
                        onChange={(e) =>
                          handleUpdateProp(
                            "stroke",
                            e.target.value === "on" ? "#000" : null
                          )
                        }
                      >
                        <option value="off">off</option>
                        <option value="on">on</option>
                      </select>
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {selectedObject &&
                selectedObject.stroke &&
                selectedEffect?.printMethodDetails?.changeStrokeColor ? (
                  <>
                    <div className="flex justify-between items-center py-2 border-t border-solid border-lightgrey">
                      <div className="font-bold">Outline Color</div>
                      <div className="flex justify-center relative">
                        <div
                          onClick={() =>
                            setShowOutlineColorPicker((prev) => !prev)
                          }
                          className="cursor-pointer w-[20px] h-[20px] rounded-full border-2 border-solid border-lightgrey"
                          style={{
                            backgroundColor: selectedObject
                              ? selectedObject.stroke
                              : currentColor,
                          }}
                        ></div>
                        <ColorPicker
                          title="Choose outline color"
                          colors={availableColors}
                          show={showOutlineColorPicker}
                          setShowColorPicker={setShowOutlineColorPicker}
                          setNewColor={setStrokeColor}
                        />
                      </div>
                    </div>

                    <div className="flex justify-between items-center gap-3 py-2 border-t border-solid border-lightgrey">
                      <div className="font-bold">Outline</div>
                      <div className="flex w-full items-center gap-3">
                        <RangeSlider
                          min={0}
                          max={5}
                          defaultValue={
                            selectedObject ? selectedObject.angle : 0
                          }
                          onChange={(angle: number) =>
                            handleUpdateProp("strokeWidth", angle)
                          }
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}

                <div className="flex justify-between items-center gap-3 py-2 border-t border-solid border-lightgrey">
                  <div className="font-bold">Size</div>
                  <div className="flex w-full items-center gap-3">
                    <RangeSlider
                      min={24}
                      max={172}
                      defaultValue={
                        selectedObject ? selectedObject.fontSize : 32
                      }
                      onChange={(size: number) =>
                        handleUpdateProp("fontSize", size)
                      }
                    />
                  </div>
                </div>
                <div className="flex justify-between items-center gap-2 flex-wrap py-4 border-t border-solid border-lightgrey text-center">
                  <div>
                    <div className={styles.inputGroup}>
                      <button
                        onClick={() =>
                          handleUpdateProp("objectAlignment", "horizontal")
                        }
                      >
                        <svg
                          width="25"
                          height="8"
                          viewBox="0 0 25 8"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M11.1667 2.00003C11.1667 1.26403 11.7587 0.666695 12.5 0.666695C13.236 0.666695 13.8333 1.2587 13.8333 2.00003V6.00003C13.8333 6.73603 13.2413 7.33336 12.5 7.33336C11.764 7.33336 11.1667 6.74136 11.1667 6.00003V2.00003ZM18.8027 5.34403C17.5307 4.60136 17.5293 3.40003 18.8027 2.65603L22.1973 0.677362C23.4693 -0.0653046 24.5 0.525361 24.5 1.99603V6.00403C24.5 7.4747 23.4707 8.06669 22.1973 7.32403L18.8027 5.34403ZM6.19733 5.34403L2.80267 7.32269C1.52933 8.06669 0.5 7.4747 0.5 6.00403V1.99603C0.5 0.525361 1.53067 -0.0653052 2.80267 0.676028L6.19733 2.65603C7.47067 3.40003 7.46933 4.6027 6.19733 5.34403Z"
                            fill="#222020"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() =>
                          handleUpdateProp("objectAlignment", "vertical")
                        }
                      >
                        <svg
                          width="9"
                          height="24"
                          viewBox="0 0 9 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M6.50009 10.6667C7.23609 10.6667 7.83343 11.2587 7.83343 12C7.83343 12.736 7.24143 13.3333 6.50009 13.3333H2.50009C1.76409 13.3333 1.16676 12.7413 1.16676 12C1.16676 11.264 1.75876 10.6667 2.50009 10.6667H6.50009ZM3.15609 18.3027C3.89876 17.0307 5.10009 17.0293 5.84409 18.3027L7.82276 21.6973C8.56543 22.9693 7.97476 24 6.50409 24H2.49609C1.02543 24 0.433427 22.9707 1.17609 21.6973L3.15609 18.3027ZM3.15609 5.69733L1.17743 2.30267C0.433428 1.02933 1.02543 0 2.49609 0H6.50409C7.97476 0 8.56543 1.03067 7.82409 2.30267L5.84409 5.69733C5.10009 6.97067 3.89743 6.96933 3.15609 5.69733Z"
                            fill="#222020"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => handleUpdateProp("objectAlignment")}
                      >
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 32 32"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M17.3333 18C17.3333 18.736 16.7413 19.3333 16 19.3333C15.264 19.3333 14.6667 18.7413 14.6667 18V14C14.6667 13.264 15.2587 12.6667 16 12.6667C16.736 12.6667 17.3333 13.2587 17.3333 14V18ZM9.69733 14.656C10.9693 15.3987 10.9707 16.6 9.69733 17.344L6.30267 19.3227C5.03066 20.0653 4 19.4747 4 18.004V13.996C4 12.5253 5.02933 11.9333 6.30267 12.676L9.69733 14.656ZM22.3027 14.656L25.6973 12.6773C26.9707 11.9333 28 12.5253 28 13.996V18.004C28 19.4747 26.9693 20.0653 25.6973 19.324L22.3027 17.344C21.0293 16.6 21.0307 15.3973 22.3027 14.656Z"
                            fill="#222020"
                          />
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M18.0001 14.6667C18.7361 14.6667 19.3334 15.2587 19.3334 16C19.3334 16.736 18.7414 17.3333 18.0001 17.3333H14.0001C13.2641 17.3333 12.6668 16.7413 12.6668 16C12.6668 15.264 13.2588 14.6667 14.0001 14.6667H18.0001ZM14.6561 22.3027C15.3988 21.0307 16.6001 21.0293 17.3441 22.3027L19.3228 25.6973C20.0654 26.9693 19.4748 28 18.0041 28H13.9961C12.5254 28 11.9334 26.9707 12.6761 25.6973L14.6561 22.3027ZM14.6561 9.69733L12.6774 6.30267C11.9334 5.02933 12.5254 4 13.9961 4H18.0041C19.4748 4 20.0654 5.03067 19.3241 6.30267L17.3441 9.69733C16.6001 10.9707 15.3974 10.9693 14.6561 9.69733Z"
                            fill="#222020"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="text-[10px]">Center</div>
                  </div>
                  <div>
                    <div className={styles.inputGroup}>
                      <button onClick={() => handleUpdateProp("bringForward")}>
                        <svg
                          width="19"
                          height="20"
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.6646 10.406L9.89798 15.2936C9.7935 15.3601 9.67226 15.3953 9.54845 15.3953C9.42465 15.3953 9.30341 15.3601 9.19893 15.2936L1.43322 10.406C1.33293 10.3422 1.25056 10.2539 1.1939 10.1494C1.13724 10.0449 1.10816 9.92773 1.10941 9.80887C1.10941 9.56221 1.23036 9.33935 1.43322 9.21173L2.57607 8.49173L8.87131 12.4527C9.07414 12.5807 9.30908 12.6487 9.54893 12.6487C9.78878 12.6487 10.0237 12.5807 10.2266 12.4527L16.5208 8.49078L17.6637 9.21173C17.8675 9.33935 17.9885 9.56221 17.9885 9.80887C17.9896 9.92771 17.9605 10.0449 17.9038 10.1494C17.8472 10.2538 17.7649 10.3422 17.6646 10.406ZM17.6646 12.6136C17.8675 12.7413 17.9885 12.9641 17.9885 13.2108C17.9897 13.3296 17.9606 13.4468 17.904 13.5513C17.8473 13.6558 17.7649 13.7441 17.6646 13.8079L9.89798 18.6946C9.79354 18.7611 9.67229 18.7965 9.54845 18.7965C9.42462 18.7965 9.30337 18.7611 9.19893 18.6946L1.43322 13.8079C1.33293 13.7441 1.25056 13.6558 1.1939 13.5513C1.13724 13.4468 1.10816 13.3296 1.10941 13.2108C1.10941 12.9641 1.23036 12.7413 1.43322 12.6136L2.57607 11.8936L8.87131 15.8546C9.07414 15.9826 9.30908 16.0506 9.54893 16.0506C9.78878 16.0506 10.0237 15.9826 10.2266 15.8546L16.5208 11.8927L17.6646 12.6136ZM18.6218 9.80887C18.6218 9.33078 18.3866 8.8984 17.9932 8.65078L17.1304 8.10792L17.9923 7.56506C18.3866 7.31745 18.6208 6.88411 18.6208 6.40697C18.6208 5.92887 18.3866 5.49649 17.9923 5.24887L10.2266 0.361255C10.024 0.232465 9.78895 0.164063 9.54893 0.164062C9.30891 0.164063 9.07386 0.232465 8.87131 0.361255L1.10465 5.24983C0.711312 5.49745 0.476074 5.92983 0.476074 6.40792C0.476074 6.88507 0.711312 7.3184 1.10465 7.56602L1.96655 8.10887L1.10465 8.65173C0.711312 8.89935 0.476074 9.33173 0.476074 9.80983C0.476074 10.287 0.711312 10.7203 1.10465 10.9679L1.96655 11.5108L1.10465 12.0536C0.711312 12.3013 0.476074 12.7336 0.476074 13.2117C0.476074 13.6889 0.711312 14.1222 1.10465 14.3698L8.87131 19.2574C9.07414 19.3855 9.30908 19.4534 9.54893 19.4534C9.78878 19.4534 10.0237 19.3855 10.2266 19.2574L17.9923 14.3698C18.3866 14.1222 18.6208 13.6889 18.6208 13.2117C18.6208 12.7336 18.3866 12.3013 17.9923 12.0536L17.1304 11.5108L17.9923 10.9679C18.3866 10.7203 18.6208 10.287 18.6208 9.80983L18.6218 9.80887Z"
                            fill="#4A4A4A"
                          />
                        </svg>
                      </button>
                      <button onClick={() => handleUpdateProp("sendBackwards")}>
                        <svg
                          width="19"
                          height="20"
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.6646 10.406L9.89798 15.2936C9.7935 15.3601 9.67226 15.3953 9.54845 15.3953C9.42465 15.3953 9.30341 15.3601 9.19893 15.2936L1.43322 10.406C1.33293 10.3422 1.25056 10.2539 1.1939 10.1494C1.13724 10.0449 1.10816 9.92773 1.10941 9.80887C1.10941 9.56221 1.23036 9.33935 1.43322 9.21173L2.57607 8.49173L8.87131 12.4527C9.07414 12.5807 9.30908 12.6487 9.54893 12.6487C9.78878 12.6487 10.0237 12.5807 10.2266 12.4527L16.5208 8.49078L17.6637 9.21173C17.8675 9.33935 17.9885 9.56221 17.9885 9.80887C17.9896 9.92771 17.9605 10.0449 17.9038 10.1494C17.8472 10.2538 17.7649 10.3422 17.6646 10.406ZM1.10845 6.40602C1.10845 6.1603 1.23036 5.93745 1.43226 5.80983L9.19988 0.922208C9.30448 0.856109 9.42568 0.821025 9.54941 0.821025C9.67314 0.821025 9.79433 0.856109 9.89893 0.922208L17.6656 5.80983C17.8685 5.93745 17.9894 6.1603 17.9894 6.40697C17.9907 6.52582 17.9616 6.64303 17.9049 6.74752C17.8483 6.852 17.7659 6.94032 17.6656 7.00411L9.89893 11.8917C9.7945 11.9583 9.67324 11.9936 9.54941 11.9936C9.42558 11.9936 9.30432 11.9583 9.19988 11.8917L1.43417 7.00411C1.33388 6.94032 1.25152 6.852 1.19486 6.74752C1.1382 6.64303 1.10912 6.52582 1.11036 6.40697M18.6227 9.80887C18.6227 9.33078 18.3875 8.8984 17.9942 8.65078L17.1313 8.10792L17.9932 7.56506C18.3875 7.31745 18.6218 6.88411 18.6218 6.40697C18.6218 5.92887 18.3875 5.49649 17.9932 5.24887L10.2266 0.361255C10.024 0.232465 9.78895 0.164062 9.54893 0.164062C9.30891 0.164063 9.07386 0.232465 8.87131 0.361255L1.10465 5.24983C0.711312 5.49745 0.476074 5.92983 0.476074 6.40792C0.476074 6.88507 0.711312 7.3184 1.10465 7.56602L1.96655 8.10887L1.10465 8.65173C0.711312 8.89935 0.476074 9.33173 0.476074 9.80983C0.476074 10.287 0.711312 10.7203 1.10465 10.9679L1.96655 11.5108L1.10465 12.0536C0.711312 12.3013 0.476074 12.7336 0.476074 13.2117C0.476074 13.6889 0.711312 14.1222 1.10465 14.3698L8.87131 19.2574C9.07414 19.3855 9.30908 19.4534 9.54893 19.4534C9.78878 19.4534 10.0237 19.3855 10.2266 19.2574L17.9923 14.3698C18.3866 14.1222 18.6208 13.6889 18.6208 13.2117C18.6208 12.7336 18.3866 12.3013 17.9923 12.0536L17.1304 11.5108L17.9923 10.9679C18.3866 10.7203 18.6208 10.287 18.6208 9.80983"
                            fill="#4A4A4A"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="text-[10px]">Layering</div>
                  </div>
                  <div>
                    <div className={styles.inputGroup}>
                      <button
                        onClick={() => handleUpdateProp("originX", "right")}
                      >
                        <svg
                          width="16"
                          height="14"
                          viewBox="0 0 16 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.773193 11.9178H15.2345V13.4571H0.773193V11.9178Z"
                            fill="#4A4A4A"
                          />
                          <path
                            d="M0.773193 0.542847H15.2345V2.0821H0.773193V0.542847Z"
                            fill="#4A4A4A"
                          />
                          <path
                            d="M0.773193 6.23035H9.44687V7.7696H0.773193V6.23035Z"
                            fill="#4A4A4A"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => handleUpdateProp("originX", "center")}
                      >
                        <svg
                          width="16"
                          height="14"
                          viewBox="0 0 16 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.773193 11.9178H15.2345V13.4571H0.773193V11.9178Z"
                            fill="#4A4A4A"
                          />
                          <path
                            d="M0.773193 0.542847H15.2345V2.0821H0.773193V0.542847Z"
                            fill="#4A4A4A"
                          />
                          <path
                            d="M3.65942 6.23035H12.3331V7.7696H3.65942V6.23035Z"
                            fill="#4A4A4A"
                          />
                        </svg>
                      </button>
                      <button
                        onClick={() => handleUpdateProp("originX", "left")}
                      >
                        <svg
                          width="16"
                          height="14"
                          viewBox="0 0 16 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.773193 11.9178H15.2345V13.4571H0.773193V11.9178Z"
                            fill="#4A4A4A"
                          />
                          <path
                            d="M0.773193 0.542847H15.2345V2.0821H0.773193V0.542847Z"
                            fill="#4A4A4A"
                          />
                          <path
                            d="M6.55322 6.23035H15.2269V7.7696H6.55322V6.23035Z"
                            fill="#4A4A4A"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="text-[10px]">Text Alignment</div>
                  </div>
                </div>
              </div>
            </>
          </>
        )}
      </>
    </>
  );
};

export default AddText;
